// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tip-tip_20b4f168","top":"Tip-top_cddebafb","bottom":"Tip-bottom_e9f5e853","left":"Tip-left_78f967c9","right":"Tip-right_3f876e8a"};